<template>
  <QsDrawer
    :title="title"
    :visible.sync="visible"
    :append-to-body="true"
    :before-close="() => emit('input', false)"
  >
    <div class="drawer-container">
      <el-alert
        v-if="operate === DRAWER_OPERATIONS.APPLY_INVOICE.name"
        :show-icon="false"
        :closable="false"
        style="text-align: center; margin-bottom: 20px"
      >
        <div style="color: #276BEC;">请注意核对开票信息，如有误请及时联系车为家商务进行更新</div>
      </el-alert>
      <Descriptions :data="dataSource" :config="config.columns" />
    </div>
    <template slot="footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">确认</el-button>
    </template>
  </QsDrawer>
</template>
<script setup>
import { ref, watch } from 'vue'
import { DRAWER_OPERATIONS } from '../config'
import { Message } from '@qs/ui'
import Descriptions from './Descriptions.vue'

const props = defineProps({
  // 操作
  operate: {
    type: String,
    default: DRAWER_OPERATIONS.CONFIRM_BILL,
  },
  // 账单
  billId: Number,
  value: Boolean,
})

const emit = defineEmits(['input', 'confirm'])

// 抽屉展示标识
const visible = ref(props.value)
// 抽屉标题
const title = ref('')

// 提交加载标识
const loading = ref(false)

// 操作配置
const config = ref(DRAWER_OPERATIONS[props.operate])

// 内容数据
const dataSource = ref({})

const submit = () => {
  loading.value = true
  config.value.submitApi(props.billId).then((res) => {
    const { code, data } = res
    if (code === 1 && data) {
      Message.success(config.value.successText)
      cancel()
      emit('confirm')
    }
  }).finally(() => {
    loading.value = false
  })
}

const cancel = () => {
  visible.value = false
  emit('input', false)
}

watch(() => props.value, (val) => {
  visible.value = val
  if (val) {
    // 抽屉显示时触发组件show
    config.value = DRAWER_OPERATIONS[props.operate]
    config.value.show(props.billId).then((res) => {
      title.value = config.value.getTitle(res)
      dataSource.value = res
    })
  }
})
</script>
<style lang="less" scoped>
.el-alert {
  color: #276BEC;
}
.drawer-container {
  margin: 8px 16px;
}
</style>
